import { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const Pflegehelfer = () => {
  const [salaryInfo, setSalaryInfo] = useState({
    pflegehelfer_gehalt: '3.568,87 €',
    pflegefachkraft_gehalt: '4.643,51 €',
    urlaub_tage: 30,
    updated_at: null
  });
  
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchSalaryInfo();
  }, []);
  
  const fetchSalaryInfo = async () => {
    try {
      const response = await fetch(`${API_URL}/api/salary/leipzig`);
      if (response.ok) {
        const data = await response.json();
        setSalaryInfo({
          pflegehelfer_gehalt: data.pflegehelfer_gehalt || '3.568,87 €',
          pflegefachkraft_gehalt: data.pflegefachkraft_gehalt || '4.643,51 €',
          urlaub_tage: data.urlaub_tage || 30,
          updated_at: data.updated_at || null
        });
      }
    } catch (err) {
      console.error('Failed to fetch salary info:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const benefits = [
    'Dienstpläne werden 3-4 Wochen vorher ausgeteilt',
    'Freie Tage bleiben auch freie Tage',
    'Dienstzeiten: Früh 06:00-14:30 Uhr, Spät 13:30-22:00 Uhr',
    'Fast keine Überstunden, Jahresarbeitszeitkonto',
    'Kommunikation und Ehrlichkeit',
    '30 Tage Urlaub',
    'Touren nicht überfüllt',
    'Dienstkleidung optional',
    'Keine Teildienste',
    'Liebevolle und herzliche Klienten'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-turquoise-50 to-white">
      <Header />
      
      <section className="relative py-20 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-turquoise-400 to-turquoise-300 opacity-10"></div>
        <div className="container mx-auto text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pflegehelfer (m, w, d)
          </h1>
          <p className="text-xl text-gray-600">Voll- und Teilzeit</p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
            <blockquote className="text-2xl font-semibold text-center text-gray-800 mb-12 italic">
              "Wir wissen nicht, ob es besser wird, wenn sich etwas ändert, aber wir wissen, dass es anders werden muss, wenn es besser werden soll."
            </blockquote>

            <div className="prose prose-lg max-w-none mb-12">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Im Grunde müsste jetzt bei der Stellenausschreibung die Aufgaben in der Ambulanten Pflege dargestellt werden, aber grundsätzlich sind diese jedem bekannt. Daher konzentrieren wir uns einfach auf das Wesentliche.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Wir stellen einfach mal dar, warum wir anders und stolz drauf sind:
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mb-12">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-start space-x-3 p-4 bg-turquoise-50 rounded-xl">
                  <svg className="w-6 h-6 text-turquoise-400 flex-shrink-0 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-gray-700">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 mb-12 border-l-4 border-green-600">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Konditionen:</h3>
              <ul className="space-y-3 text-lg text-gray-700">
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">€</span>
                  <span><strong>{salaryInfo.pflegehelfer_gehalt} brutto</strong> bei Vollzeit</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">+</span>
                  <span>Sonntags- und Feiertagszuschlag</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">☀️</span>
                  <span>{salaryInfo.urlaub_tage} Tage Urlaub</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">🚗</span>
                  <span>Neue Dienstwagen (Führerschein erforderlich)</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">🔑</span>
                  <span>Möglichkeit zur privaten Nutzung (1%-Regelung)</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">📅</span>
                  <span>Wunschfrei</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-green-600 text-2xl">✓</span>
                  <span>Unbefristetes Arbeitsverhältnis</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-r from-turquoise-400 to-turquoise-400 text-white rounded-2xl p-8 mb-8">
              <p className="text-lg leading-relaxed mb-4">
                Kevin und ich haben diesen Pflegedienst nicht gegründet, um Millionär zu werden, sondern da uns das Wohl der Menschen am Herzen liegt und daher folgen noch weitere wunderbare Projekte, um denjenigen Menschen Hilfe anzubieten, die sie benötigen.
              </p>
              <p className="text-lg leading-relaxed">
                Wenn wir euch überzeugt haben, dass wir anders sein könnten, dann meldet euch und wir legen es euch nicht nur schriftlich dar, sondern zeigen es euch auch.
              </p>
            </div>

            <div className="text-center">
              <p className="text-xl font-bold text-gray-900 mb-6">
                Bereichern Sie unser grandioses Team von wunderbaren dynamischen und unendlich empathischen Menschen!
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="tel:034124927833"
                  className="bg-turquoise-400 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-500 transition-all shadow-lg"
                >
                  Jetzt anrufen: 0341-24927833
                </a>
                <a 
                  href="mailto:info@grossstadtherzen.de"
                  className="bg-turquoise-400 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-turquoise-500 transition-all shadow-lg"
                >
                  E-Mail senden
                </a>
              </div>
            </div>

            <p className="text-center text-gray-600 mt-8">
              <small>Aktualisiert: {formatDate(salaryInfo.updated_at) || 'Kürzlich'}</small>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pflegehelfer;